import { Dimensions, StyleSheet, Text, View } from 'react-native'
import React, { useEffect } from 'react'
import AppIntroSlider from 'react-native-app-intro-slider'
import WelcomeFirst from './WelcomeFirst'
import WelcomeSecond from './WelcomeSecond'
import WelcomeThird from './WelcomeThird'
import WelcomeFourth from './WelcomeFourth'
import WelcomeFifth from './WelcomeFifth'
import WelcomeSix from './WelcomeSix'
import WelcomeLast from './WelcomeLast'
import { useHomeStore } from '../../../stores/home'
import { useInitializeStore } from '../../../stores/initialize'
import WelcomeSeven from './WelcomeSeven'
import WelcomeEight from './WelcomeEight'

const slides = [
  {
    key: 'slide1',
    component: <WelcomeFirst />,
    backgroundColor: '#0B495C'
  },
  {
    key: 'slide2',
    component: <WelcomeSecond />,
    backgroundColor: '#0B495C'
  },
  {
    key: 'slide3',
    component: <WelcomeThird />,
    backgroundColor: '#0B495C'
  },
  {
    key: 'slide4',
    component: <WelcomeFourth />,
    backgroundColor: '#0B495C'
  },
  {
    key: 'slide5',
    component: <WelcomeFifth />,
    backgroundColor: '#0B495C'
  },
  {
    key: 'slide6',
    component: <WelcomeSix />,
    backgroundColor: '#0B495C'
  },

  {
    key: 'slide7',
    component: <WelcomeSeven />,
    backgroundColor: '#0B495C'
  },

  {
    key: 'slide8',
    component: <WelcomeEight />,
    backgroundColor: '#0B495C'
  },
  {
    key: 'slide9',
    component: <WelcomeLast />,
    backgroundColor: '#0B495C'
  }
]

const WelcomeSlider = ({ navigation, route }) => {
  const homestore = useHomeStore()
  const initializestore = useInitializeStore()
  useEffect(() => {
    homestore.fetchfirsttime(initializestore.initializeData?.userkey)
  }, [])
  const renderItem = ({ item }) => (
    <View
      style={{
        backgroundColor: item.backgroundColor,
        height: Dimensions.get('window').height,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}
    >
      {item.component}
    </View>
  )

  const onDone = () => {
    homestore.PostfirstTime(initializestore.initializeData.userkey)
    navigation.navigate('HomeStack')
  }

  const onSkip = () => {
    homestore.PostfirstTime(initializestore.initializeData.userkey)
    navigation.navigate('HomeStack')
  }

  return (
    <AppIntroSlider
      renderItem={renderItem}
      data={slides}
      onDone={onDone}
      onSkip={onSkip}
      showSkipButton
      activeDotStyle={{
        backgroundColor: '#87CEEB',
        width: 20,
        borderRadius: 10
      }}
    />
  )
}

export default WelcomeSlider
const styles = StyleSheet.create({
  // slide: {
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   padding: 20,
  //   height: '100%'
  // }
})
